<template>
    
    <div >
       <div class="breadcrumb">
           <div class="container">
               <router-link class="btn btn-primary" to="/">Назад</router-link>
           </div>
       </div>
       <div class="container">
               <div class="card loading" v-show="!loading">
                   <div class="card-header">
                       <h4>{{show.title}}</h4>
                   </div>
                   <div class="card-body">
                       <img 
                           v-show="!!show.image"
                           class="show-img"
                           :src="show.image" 
                           >
                       <p 
                           class="card-text description" 
                           v-show="!!show.description"
                           v-html="show.description"></p>
                       <div 
                           class="alert alert-secondary" 
                           role="alert"
                           v-show="!show.description"
                           >
                           Описание отсутствует.
                       </div>
                       <h2 class="card-title">Список серий</h2>
                       <hr>
                   </div>
                   <div 
                       v-for="(season, index) in seasons"
                       class="card-body">
                       <h4 class="card-title">Сезон {{seasons.length - index}}</h4>
                       
                       <ul class="list-group">
                           <li 
                               v-for="item in season"
                               class="list-group-item list-group-item-action flex-column align-items-start"
                               >
                               <div class="d-flex w-100 justify-content-between">
                                   <p class="mb-1">
                                       {{item.title}}
                                       <span class="badge badge-pill badge-info">
                                           {{item.shortName}}
                                       </span>
                                   </p>
                                   <small 
                                       class="btn btn-sm" 
                                       :class="{
                                          'btn-info': !getAirDateInfo(item.airDate).status,
                                          'btn-light': getAirDateInfo(item.airDate).status
                                       }">
                                       {{getAirDateInfo(item.airDate).text}}
                                   </small>
                               </div>
                           </li>
                       </ul>
                   </div>
               </div>
          </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    
    export default {
        data() {
            return {
                show: {},
                seasons: [],
                loading: true
            }
        },
        methods: {
            getAirDateInfo(time) {
                if (time == null){
                    var status = true,
                        parsedTime = 'Не указана'
                } else{
                    time = this.parseDateToValid(time);
                    var parsedTime = new Date(time).getTime(),
                        now = new Date().getTime(),
                        status = parsedTime < now;

                    if (parsedTime < now) {
                        parsedTime = 'Серия вышла'
                    } else {
                        parsedTime = new Date(time);
                        var day = parsedTime.getDate(),
                            month = parsedTime.getMonth() + 1,
                            year = parsedTime.getFullYear();
                        if (day.toString().length == 1) {
                            day = '0' + day;
                        }
                        if (month.toString().length == 1) {
                            month = '0' + month;
                        }
                        parsedTime = day + '.' + month + '.' + year;
                        parsedTime = 'Ожидается ' + parsedTime
                    }
                }
                return {
                    status: status,
                    text: parsedTime
                }
            },
            parseDateToValid(date){
              var year = date.slice(0,4),
                  month = date.slice(5,7),
                  day = date.slice(8,10);
              return month+'/'+day+'/'+year;
            }
        },
        activated() {
            this.loading = true;
            let params = {
                "jsonrpc": "2.0",
                "method": "shows.GetById",
                "params": {
                    "showId": this.$route.params.id,
                    "withEpisodes": true
                },
                "id": 1
            };
            this.$http.post(
                    'https://api.myshows.me/v2/rpc/',
                    params
                )
                .then(response => {
                    this.show = response.body.result;
                    let episodesList = response.body.result.episodes;
                    episodesList = _.groupBy(episodesList, 'seasonNumber');
                    let reversedObj = [];
                    _.forEachRight(episodesList, function(val, key){
                        reversedObj.push(val)
                    })
                    this.seasons = reversedObj;
                    this.loading = false;
                });
        }
    }

</script>


<style>
    .show-img {
        margin-bottom: 30px;
    }
    
    .description {
        margin-bottom: 40px;
    }
    
    img,
    iframe {
        margin: 0 auto;
        display: block;
        max-width: 100%;
    }

</style>



// WEBPACK FOOTER //
// src/comp/Show.vue?1c27548f